import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconAnnotationNumbers16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconAnnotationNumbers16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.935 5.455V10h.96V4.75H3.163L2.09 7.12h1.005L3.8 5.455zm3.588.55a.5.5 0 0 0 0 1h5.943a.5.5 0 0 0 0-1zm-.5 4.5a.5.5 0 0 1 .5-.5h5.943a.5.5 0 0 1 0 1H7.523a.5.5 0 0 1-.5-.5m.5-2.5a.5.5 0 0 0 0 1h3.629a.5.5 0 0 0 0-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconAnnotationNumbers16);
